module.exports = __webpack_public_path__ + "assets/img/DS-kitchen (3).d66c5a7c.jpg";